import { uploadPictureToS3 } from "@knowt/syncing/utils/s3";
import { toast } from "react-hot-toast";

export const uploadImage = async (file: File, customBucketName?: string) => {
    const toastId = toast.loading(`Uploading image...`);
    const { url, id } = await uploadPictureToS3(file, customBucketName ?? "knowt-user-attachments", file.type);
    toast.success("Image uploaded!", { id: toastId });
    return { url, id };
};
